import type { LiveBlock } from "../../shared/types";

export type BlockPresentationListener = (block: LiveBlock) => void;

export interface BlockPresentationChannel {
  publish(block: LiveBlock): void;
  subscribe(listener: BlockPresentationListener): () => void;
}

export function createBlockPresentationChannel(): BlockPresentationChannel {
  const listeners = new Set<BlockPresentationListener>();
  const presented = new Set<string>();
  const presentationOrder: string[] = [];
  return {
    publish(block) {
      if (presented.has(block.blockNumber)) return;
      presented.add(block.blockNumber);
      presentationOrder.push(block.blockNumber);
      if (presentationOrder.length > 256) presented.delete(presentationOrder.shift()!);
      for (const listener of listeners) listener(block);
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
